import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getQuoteJobUnreadCount } from "./ClientMessagesList";
import styles from "./ClientMessagesList.module.css";
function getDisplayName(thread, prefix) {
    const contactName = thread.contactName ?? "Unknown";
    const number = prefix === "quote" ? thread.quoteNumber : thread.jobNumber;
    if (number) {
        const label = prefix === "quote" ? "Quote" : "Job";
        return `${label} #${number} - ${contactName}`;
    }
    return contactName;
}
export const QuoteJobThreadsList = ({ threads, selectedThreadId, onSelectThread, loading = false, emptyMessage = "No conversations yet.", displayPrefix, }) => {
    if (loading) {
        return (_jsx("div", { className: styles.loading, children: "Loading conversations\u2026" }));
    }
    if (threads.length === 0) {
        return (_jsx("div", { className: styles.listEmpty, children: emptyMessage }));
    }
    return (_jsx(_Fragment, { children: threads.map((thread) => {
            const displayName = getDisplayName(thread, displayPrefix);
            const initial = (thread.contactName ?? "?").charAt(0).toUpperCase();
            const isActive = thread.id === selectedThreadId;
            const effectiveUnread = getQuoteJobUnreadCount(thread);
            return (_jsxs("div", { role: "button", tabIndex: 0, className: `${styles.contactItem} ${isActive ? styles.contactItemActive : ""}`, onClick: () => onSelectThread(thread), onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onSelectThread(thread);
                    }
                }, children: [_jsx("div", { className: styles.contactAvatar, children: initial }), _jsx("div", { className: styles.contactInfo, children: _jsxs("div", { className: styles.contactNameRow, children: [_jsx("span", { className: styles.contactName, children: displayName }), effectiveUnread > 0 && (_jsx("span", { className: styles.unreadBadge, children: effectiveUnread > 99 ? "99+" : effectiveUnread }))] }) })] }, thread.id));
        }) }));
};
